package com.neurobs.ccabserver.subjectsessionview.components.sessionview

import com.neurobs.ccab.SessionViewResult
import com.neurobs.ccabserver.subjectsessionview.components.PropertyLabel
import com.neurobs.ccabserver.subjectsessionview.states.{SessionSelectionStateGenerator, UserState}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement

@react
object SubjectInfo {
  case class Props(enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>

    val userState = UserState.accessState
    val sessionSelectionState = SessionSelectionStateGenerator.accessState

    def reportingId(sessionViewResult: SessionViewResult): String = sessionViewResult.session.reportingId.noBracketsString
    def name(sessionViewResult: SessionViewResult): String = {
      val sessionReportingId = reportingId(sessionViewResult)
      sessionViewResult.identity.map(_.displayName(sessionReportingId)).getOrElse(sessionReportingId)
    }

    def withSameAdmin = sessionSelectionState.withSameAdmin
    def withSameStation = sessionSelectionState.withSameStation
    def withSameStudy = sessionSelectionState.withSameStudy


    sessionSelectionState.sessionsState.value match {
      case Left(_) => null
      case Right(sessions) =>
          if (sessions.isEmpty) null
          else {
            val sessionDisplayData = sessions.head
            props.enclosingElement(
              Seq[ReactElement](
                PropertyLabel("Subject", name(sessionDisplayData.session)),
                PropertyLabel("Reporting Id", reportingId(sessionDisplayData.session)),
                withSameAdmin match {
                  case None => null
                  case Some(adminOpt) => PropertyLabel("Examiner", adminOpt.getOrElse("Unknown"))
                },
                withSameStation match {
                  case None => null
                  case Some(station) => PropertyLabel("Station", station)
                },
                withSameStudy match {
                  case None => null
                  case Some(study) => PropertyLabel("Study", study)
                },
              )
            )
          }

    }
  }

}
